import { Box, styled, Theme, useTheme } from "@mui/material";
import { Link, Typography } from "@platform/design-system";

import type { JSX } from "react";

interface Props {
  onDownload: () => void;
}

const CensusSuccessful = ({ onDownload }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Box>
      <StyledBoxImg1>
        <Typography
          variant="display-medium"
          color="inherit"
          mb={theme.spacing(2)}
        >
          Thank you!
        </Typography>
        <Typography
          variant="header-large"
          color="inherit"
          display="flex"
          mt={theme.spacing(1)}
        >
          This census has been successfully processed.
        </Typography>
        <StyledSvg viewBox="0 0 800 30">
          <path d="M 0 0 Q 400 50 800 0" fill="#832a7f" />
        </StyledSvg>
      </StyledBoxImg1>
      <Box justifyContent="center" textAlign="center" mt={theme.spacing(3)}>
        <Typography>
          Click{" "}
          <Link component="button" underline="hover" onClick={onDownload}>
            <strong>here</strong>
          </Link>{" "}
          to download the newly structured census.
        </Typography>
      </Box>
    </Box>
  );
};

const StyledBoxImg1 = styled(Box)(({ theme }: { theme: Theme }) => ({
  background:
    "radial-gradient(at top left, rgba(13,111,157,1) 15%, rgba(131,42,127,1) 60%)",
  backgroundPosition: "center",
  color: theme.palette.common.white,
  flexDirection: "column",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  height: 250,
  position: "relative",
}));

const StyledSvg = styled("svg")(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.common.white,
  position: "absolute",
  bottom: 0,
}));

export default CensusSuccessful;
